import React, { memo } from "react";
//import Header from "../../components/Header";
//import HeaderContainer from '../../components/Header/HeaderContainer';
//import Footer1 from "../GenericUI/Footer1";
//import FooterContainer from "../../components/Footer/FooterContainer";
import history from "../History";
import Button from "../GenericUI/Button";
import { useState, useEffect } from "react";
import { setPageName } from "../../Redux/Actions/webAppActions";
import { useDispatch } from "react-redux";
const GlobalErrorPage = (props) => {
  const [err, setErr] = useState({msg:"",isSsoUser:false});
  const dispatch = useDispatch();
  useEffect(() => {
    let url = decodeURIComponent(window.location.href);
    let queryStrings = url.split("?")[1]?.split("&")??[];
    let errState={...err}
    queryStrings.forEach((q)=>errState={...errState,...{[`${q.split("=")?.[0]}`]:`${q.split("=")?.[1]}`}})
    console.log("queryStrings-",queryStrings,errState)
    setErr(errState);
    history.push("/e-Enroll/Err-Page");
    dispatch(setPageName("Err-Page"));
  }, []);
  const {msg,isSsoUser}=err;
  return (
    <div>
      {/* <HeaderContainer hide={true}/> */}
      <div class="container-fluid">
        <div>
          <img
            src={require("../../assests/images/Errpage.png")}
            alt="Alternate Image"
            class="err-img"
          />
        </div>
        <div class="text-align-center">
          {/* global-err-container"> */}
          <h2>{msg}</h2>
          {[false,'false'].some((o)=>o===isSsoUser)?
          <>
          <p className="global-err-text-color">
            The Page you are looking for must have been removed or had it's name
            changed or is temporarily unavailable.
          </p>
          {/* <p>Click <a className="err-link" onClick={}>Here</a> to Login</p> */}
          <Button
            className="btn-primary-login"
            id="continue-to-home"
            onButtonClick={() => history.push("/e-Enroll/login")}
            buttonLabel="GO TO HOMEPAGE"
          />
          </>:null
          }
        </div>
      </div>
      {/* <div className="err-footer"> */}
        {/* <Footer1/> */}
        {/* <FooterContainer /> */}
      {/* </div> */}
    </div>
  );
};
export default memo(GlobalErrorPage)